import { Button } from "../ui/button";
import { Toggle } from "../ui/toggle"
import { EventInfoSchema } from "./EventSchema"


export function EventItem({item,  onClick, onCopyEvent, onLinksClicked }: { item: EventInfoSchema,  onClick: (id: string, isNew: boolean) => void,  onCopyEvent?: (id: string) => void, onLinksClicked?: (id: string) => void }) {
  const dateFrom = new Date(item.DateFrom);
  const dateTo = new Date(item.DateTo);
  const isSameCalendarDate =
    dateFrom.getFullYear() === dateTo.getFullYear() &&
    dateFrom.getMonth() === dateTo.getMonth() &&
    dateFrom.getDate() === dateTo.getDate();

  
  return (
    <tr key={item.Id} className="border-t hover:bg-gray-50 cursor-pointer" onClick={() => onClick(item.Id, false)}>
      
      <td className="px-4 py-2"><Toggle checked={item.Live} disabled></Toggle></td>
      <td className="px-4 py-2 text-blue-500" onClick={(e) => { e.stopPropagation(); onLinksClicked?.(item.Id); }}>Links</td>
      <td className="px-4 py-2">{item.Name}</td>
      <td className="px-4 py-2">{item.EventPath}</td>
         <td className="px-4 py-2 min-w-[120px]">{new Intl.DateTimeFormat("de-DE").format(dateFrom)} </td>
        <td className="px-4 py-2 min-w-[120px]">{isSameCalendarDate ? "" : new Intl.DateTimeFormat("de-DE").format(dateTo)} </td>
        <td className="px-4 py-2 min-w-[120px]">{new Intl.DateTimeFormat("de-DE", { hour: "2-digit", minute: "2-digit", hour12: false }).format(dateFrom)} </td>
          <td className="px-4 py-2 min-w-[120px]">{new Intl.DateTimeFormat("de-DE", { hour: "2-digit", minute: "2-digit", hour12: false }).format(dateTo)} </td> 
                  <td className="px-4 py-2 max-w-[120px]"><Button className="bg-transparent text-black" onClick={(e) => { e.stopPropagation(); onCopyEvent?.(item.Id); }}>Copy</Button></td> 
    </tr>
    
  )
}